/* eslint-disable react/no-array-index-key */
import * as React from 'react';
import { StepConnector, Step, StepButton, Stepper, StepLabel } from '@mui/material';
import { ColorPalette, TypographySettings } from '../config';
import { UniformStepType, IUniformStepperProps } from './interfaces';

export function UniformStepper(props: IUniformStepperProps) {
  const { activeStep, steps, onStepClick } = props;

  return (
    <Stepper
      connector={
        <StepConnector
          sx={{
            flex: '0 1 100px',
          }}
        />
      }
      activeStep={activeStep}
      nonLinear={!!onStepClick}
      sx={{
        backgroundColor: ColorPalette.WHITE,
        boxShadow: '0 5px 9px -10px, inset 0 5px 9px -10px',
        display: 'inline-flex',
        justifyContent: 'center',
        p: 1.5,
        position: 'relative',
        zIndex: 1,
      }}
    >
      {steps.map((x: UniformStepType, i: number) => {
        const label = (
          <StepLabel
            StepIconProps={{
              icon: '',
              sx: {
                height: '0.75rem',
                width: '0.75rem',
              },
            }}
            sx={{
              fontFamily: TypographySettings.AlternativeFontFamily,
              fontSize: '0.85rem',
              '.MuiStepLabel-iconContainer': {
                pr: x.props.stepName ? 1 : 0,
              },
            }}
          >
            {x.props.stepName}
          </StepLabel>
        );
        return (
          <Step key={`step${x.props && x.props.stepName}${i}`} completed={activeStep !== undefined && i < activeStep}>
            {onStepClick ? (
              <StepButton onClick={() => onStepClick(i)} sx={{ p: 0, m: 0 }}>
                {label}
              </StepButton>
            ) : (
              label
            )}
          </Step>
        );
      })}
    </Stepper>
  );
}
